import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/locales/en.json";
import fr from "@/locales/fr.json";
import it from "@/locales/it.json";
import es from "@/locales/es.json";
import de from "@/locales/de.json";
import ja from "@/locales/ja.json";
import ko from "@/locales/ko.json";
import zh from "@/locales/zh.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      it: { translation: it },
      es: { translation: es },
      de: { translation: de },
      ja: { translation: ja },
      ko: { translation: ko },
      zh: { translation: zh },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "fr", "it", "es", "de", "ja", "ko", "zh"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "cartonomie_lang",
      lookupQuerystring: "lang",
    },
  });

// UI shows these 8 languages — same as the 8 markets we track prices for.
export const LANGUAGES = [
  { code: "en", label: "English", flag: "EN" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "de", label: "Deutsch", flag: "DE" },
  { code: "es", label: "Español", flag: "ES" },
  { code: "it", label: "Italiano", flag: "IT" },
  { code: "ja", label: "日本語", flag: "JP" },
  { code: "ko", label: "한국어", flag: "KR" },
  { code: "zh", label: "简体中文", flag: "ZH" },
];

// Map UI language code → backend `lang` query param (some legacy keys differ).
export const UI_TO_BACKEND_LANG = {
  en: "en",
  fr: "fr",
  de: "de",
  es: "es",
  it: "it",
  ja: "jp",   // backend uses "jp" historically; both work
  ko: "kr",   // backend uses "kr"
  zh: "zh",
};

export default i18n;
